<template>
  <v-card
    class="d-flex pa-2 flex-column align-center justify-center"
    outlined
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'fit-content',
    }"
    elevation="2"
  >
    <v-snackbar v-model="isError" absolute top right color="red">
      <v-icon dark> mdi-alert-circle </v-icon>
      <span
        >&nbsp;{{ otpErrorText }}</span
      >
    </v-snackbar>
    <div
      class="d-flex flex-column justify-center align-center"
      :style="{
        'text-align': 'center',
        width: '70%',
        padding: '50px 0px 50px 0px',
      }"
    >
      <h3>Input OTP</h3>
      <p>
        Silahkan masukkan kode OTP yang sudah dikirimkan ke nomor handphone
        anda.
      </p>
      <v-text-field
        label="Masukkan Kode OTP"
        :hint="hint"
        v-model="otp"
        persistent-hint
        outlined
      />
      <v-row align="center">
        <v-progress-linear v-if="loading" :indeterminate="loading" />
        <v-btn
          small
          color="warning"
          dark
          @click="prevStep"
          :style="{ margin: '2px' }"
          :disabled="loading"
        >
          <v-icon dark left> mdi-arrow-left </v-icon>Kembali
        </v-btn>
        <v-btn
          small
          color="primary"
          dark
          @click="nextStep"
          :style="{ margin: '2px' }"
          :disabled="loading"
        >
          Lanjut
          <v-icon dark right> mdi-arrow-right </v-icon>
        </v-btn>
      </v-row>
      <v-row align="center">
        <v-btn
          v-if="timer == 0"
          small
          dark
          @click="resendOTP"
          :style="{ margin: '2px' }"
          :disabled="loading"
        >
          resend otp
          <v-icon dark> mdi-refresh </v-icon>
        </v-btn>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { dataExpiredOtp } from '../../store/params';
import { date } from '../../lib/helpers';

export default {
  name: 'step5',
  data() {
    return {
      isError: false,
      errorMessage: '',
      check: null,
      otp: '',
      id: '',
      timer: dataExpiredOtp == null ? 300 : dataExpiredOtp,
      interval: null,
    };
  },
  computed: {
    errors: {
      get() {
        return this.$store.state.register.errors;
      },
    },
    /**
     * Text shown when the OTP is rejected.
     *
     * The backend now returns a readable reason, so it is displayed as sent.
     * The legacy `expired` marker is still recognised, and an empty reason falls
     * back to the generic wording.
     *
     * @returns {string} Message for the snackbar.
     */
    otpErrorText() {
      const reason =
        typeof this.errorMessage === 'string' ? this.errorMessage.trim() : '';

      if (reason === '') return 'OTP Invalid';
      if (reason.toLowerCase() === 'expired') return 'OTP Expired';

      return reason;
    },
    hint() {
      const second = `0${(this.timer % 60).toString()}`.slice(-2);
      const minute = `0${Math.floor(this.timer / 60).toString()}`.slice(-2);
      return this.timer == 0 ? '' : `Kirim ulang OTP dalam ${minute}:${second}`;
    },
    loading() {
      return this.$store.state.register.loading;
    },
  },
  mounted() {
    if (this.$store.state.register.step == 5) {
      this.$store.dispatch('register/getOTP', { date }).then((response) => {
        if (response) {
          this.otp = response.otp;
          this.id = response.id;
        }
      });
      this.interval = setInterval(() => {
        this.timer -= 1;
        if (this.timer == 0) {
          clearInterval(this.interval);
        }
      }, 1000);
    } else {
      this.$store.commit('register/setStep', 4);
    }
  },
  methods: {
    resendOTP() {
      if (this.timer < 1) {
        this.$store.dispatch('register/getOTP', { date }).then((response) => {
          if (response) {
            this.timer = dataExpiredOtp == null ? 300 : dataExpiredOtp;
            this.otp = response.otp;
            this.id = response.id;
            clearInterval(this.interval);
            this.interval = setInterval(() => {
              this.timer -= 1;
              if (this.timer == 0) {
                clearInterval(this.interval);
              }
            }, 1000);
          }
        });
      }
    },
    prevStep() {
      this.$store.commit('register/setStep', 4);
    },
    nextStep() {
      this.isError = false;
      if (this.otp.length > 0) {
        this.$store
          .dispatch('register/useOTP', { date, otp: this.otp })
          .then((response) => {
            if (response) {
              this.isError = false;
              this.$store.commit('register/setStep', 6);
            } else {
              this.isError = true;
              this.errorMessage = this.errors;
            }
          });
      } else {
        this.isError = true;
      }
    },
  },
};
</script>
